// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1czQW","col":"CardReaderDesc_col__eoKyO","label":"CardReaderDesc_label__264yc"};